import * as FilePond from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import confetti from 'canvas-confetti';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';


// Register the plugin
FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginFileValidateSize);
FilePond.registerPlugin(FilePondPluginFileValidateType);

import $ from 'jquery';

$(document).ready(function() {
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    const inputElement = document.querySelector('#publication_image');
    const inputElement_avatar = document.querySelector('#avatar_image');


    /// upload publication images
    if (inputElement) {
        const publicationId = inputElement.getAttribute('data-publication-id');
        if (publicationId) {
            window.pond_pg = FilePond.create(inputElement, {
                allowFileSizeValidation: true,
                maxFileSize: '10MB',
                labelMaxFileSizeExceeded: 'Images must be 10 MB or smaller. This file is {filesize}.',
                labelMaxFileSize: 'Images must be 10 MB or smaller. This file is {filesize}.',
                allowImagePreview: false,
                acceptedFileTypes: ['image/jpeg', 'image/png', 'image/webp'],
                allowMultiple: true,
                server: {
                    url: '/publications/uploadpg/' + publicationId,
                    headers: {
                        'X-CSRF-TOKEN': csrfToken
                    },
                },
                onprocessfile: (error, file) => {
                    if (error) {
                        console.error('File upload error', error);
                    } else {
                        console.log('File upload success', file);
                        const response = file.serverId;
                        try {
                            const data = JSON.parse(response);
                            if (data.result === 'success' && data.url) {
                                const img = document.createElement('img');
                                img.src = data.url;
                                img.alt = 'Uploaded Image';

                                const imgWrapper = document.createElement('div');
                                imgWrapper.classList.add('grid-item');
                                imgWrapper.appendChild(img);
                                imgWrapper.setAttribute('data-pg-id', data.pgid);
                                const deleteButtonWrapper = document.createElement('div');
                                deleteButtonWrapper.classList.add('pgs-img-btns');

                                const deleteButton = document.createElement('button');
                                deleteButton.classList.add('delete-button');
                                deleteButton.innerHTML = '<i class="fas fa-trash-alt"></i>';
                                deleteButton.onclick = () => deleteImage(data.pgid);

                                deleteButtonWrapper.appendChild(deleteButton);
                                imgWrapper.appendChild(deleteButtonWrapper);

                                const pgsImgsContainer = document.getElementById('pgs-imgs');
                                if (pgsImgsContainer) {
                                    pgsImgsContainer.appendChild(imgWrapper);
                                }

                                pond_pg.removeFile(file.id);

                                addPgDragEvents();
                            }
                        } catch (parseError) {
                            console.error('Error parsing data:', parseError);
                        }
                    }
                }
            });

            window.addBackGroundDragging();
        }
    }

    /// upload avatar
    if(typeof inputElement_avatar !== 'undefined' && inputElement_avatar !== null) {
        const userId = inputElement_avatar.getAttribute('data-user-id');
        if (userId) {
            const pond = FilePond.create(inputElement_avatar, {
                allowImagePreview: false,
                allowFileSizeValidation: true,
                maxFileSize: '10MB', 
                labelMaxFileSizeExceeded: 'Images must be 10 MB or smaller. This file is {filesize}.',
                labelMaxFileSize: 'Images must be 10 MB or smaller. This file is {filesize}.',
                acceptedFileTypes: ['image/jpeg', 'image/png', 'image/webp'],
                server: {
                    url: '/user/uploadavatar/' + userId,
                    headers: {
                        'X-CSRF-TOKEN': csrfToken
                    },
                },
                onprocessfile: (error, file) => {
                    if (error) {
                        console.error('File upload error', error);
                    } else {
                        console.log('File upload success', file);
                        const response = file.serverId; // assuming serverId contains the JSON response
                        try {
                            const data = JSON.parse(response);
                            console.log('Data retrieved:', data);

                            if (data.result === 'success' && data.url) {
                                // Update the hidden input field with the new avatar URL
                                const avatarInput = document.querySelector('input[name="avatar"]');
                                if (avatarInput) {
                                    avatarInput.value = data.url;
                                } else {
                                    console.error('Avatar input field not found');
                                }

                                // Optionally, update the displayed avatar image
                                const avatarImg = document.querySelector('#avatar-preview');
                                if (avatarImg) {
                                    avatarImg.src = data.url;
                                } else {
                                    console.error('Avatar image element not found');
                                }

                                // Remove the file from FilePond to reset
                                pond.removeFile(file.id);
                            } else {
                                console.error('Invalid response data:', data);
                            }

                        } catch (parseError) {
                            console.error('Error parsing data:', parseError);
                        }
        
                    }
                }
            });
        }
    }




    function switchToRegisterTab(email, message) {
        const registerForm = $('#registerForm');
        const registerEmail = registerForm.find('input[name="email"]');
        const registerError = registerForm.find('.errorTxt');

        if (registerEmail.length) {
            registerEmail.val(email || '');
        }

        if (message) {
            registerError.text(message).slideDown();
        } else {
            registerError.text('No account found for this email. Would you like to register?').slideDown();
        }

        const tabButton = document.querySelector('.tab-button[data-tab="register"]');
        if (tabButton) {
            openTab({ currentTarget: tabButton }, 'register');
        }
    }

    $('.form-txt-input').on('input', function() {
        const form = $(this).closest('form');
        if (form.length) {
            form.find('.errorTxt').slideUp().text('');
        }
    });

    $('form.tab-content').submit(function(event) {
        event.preventDefault();

        var formId = $(this).attr('id');
        var _data = $(this).serialize();
        var csrfToken = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            url: '/user/auth',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            },
            type: 'POST',
            data: _data,
            success: function(response) {
                var errorText = (typeof response.error === 'string') ? response.error.trim() : '';
                if (errorText !== '') {
                    $('#' + formId + ' .errorTxt').text(response.error).slideDown();

                    if (response.newUsr === true && response.email) {
                        switchToRegisterTab(response.email, response.error);
                    }
                    return;
                }

                if(typeof response.newUsr !== 'undefined' && response.newUsr === true) {
                    switchToRegisterTab(response.email || '', 'No account found for this email. Would you like to register?');
                    return;
                }

                window.location.href = '/dashboard';
            },
            error: function(xhr, status, error) {
                // Handle error response
                console.error('Login failed:', error);
                /// enable button
                $('button[type="submit"]').removeAttr('disabled');
            }
        });
    });
    
    const popularSocialMediaSites = [
        'Facebook',
        'Twitter',
        'Instagram',
        'LinkedIn',
        'TikTok',
        'YouTube'
    ];
    const socialMediaContainer = $('#social-media-container');
    const addSocialMediaButton = $('#add-social-media');
    addSocialMediaButton.on('click', function() {
        const socialMediaField = $('<div class="social-media-field"></div>');
        const select = $('<select class="social-media-select"></select>');
        popularSocialMediaSites.forEach(site => {
            select.append(`<option value="${site}">${site}</option>`);
        });
        const input = $('<input type="text" class="social-media-input" placeholder="https://">');
        const removeButton = $('<button type="button" class="remove-social-media">Remove</button>');

        removeButton.on('click', function() {
            socialMediaField.remove();
        });

        socialMediaField.append(select, input, removeButton);
        socialMediaContainer.append(socialMediaField);
    });

    // Function to open modal
    $('.open-modal').on('click', function() {
        var modalId = $(this).data('modal');
        $('#' + modalId).css('display', 'flex').hide().fadeIn();
    });

    // Function to close modal
    $('.close-modal').on('click', function() {
        $(this).closest('.modal').fadeOut(function() {
            $(this).css('display', 'none');
        });
    });

    // Close modal when clicking outside the modal content
    $(window).on('click', function(event) {
        if ($(event.target).hasClass('modal')) {
            $(event.target).fadeOut(function() {
                $(this).css('display', 'none');
            });
        }
    });


    $('#fltApply').on('click', function() {
        // Get checkbox values
        const aiUsage = $('#aiUsage').is(':checked');
        const nsfw = $('#nsfw').is(':checked');

        // Create data object
        const data = {
            aiUsage: aiUsage,
            nsfw: nsfw
        };

        // Send AJAX request
        $.ajax({
            url: '/publications/applyFilter',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function(response) {
                if(response.success) {
                    console.log('Filter applied successfully');
                    // Refresh the page
                    location.reload();
                } else {
                    console.error('Error applying filter');
                }
            },
            error: function(error) {
                console.error('Error applying filter', error);
            }
        });
    });













    

});

window.deleteImage = function(publicationId) {
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        url: `/publications/deletePg/${publicationId}`,
        type: 'POST',
        contentType: 'application/json',
        headers: {
            'X-CSRF-Token': csrfToken
        },
        success: function(data) {
            if (typeof data.result !== 'undefiend' && data.result === 'success') {
                const imgWrapper = document.querySelector(`div[data-pg-id="${publicationId}"]`);
                if (imgWrapper) {
                    imgWrapper.remove();
                } else {
                    console.error('Image wrapper not found');
                }
            } else {
                alert('Error deleting publication');
            }
        },
        error: function(error) {
            console.error('Error:', error);
        }
    }); 
}

window.toggleVote = function(publicationId) {
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        url: `/publications/vote/${publicationId}`,
        type: 'POST',
        contentType: 'application/json',
        headers: {
            'X-CSRF-Token': csrfToken
        },
        success: function(data) {
            if (data.success) {
                const voteElement = $(`#vte-${publicationId}`);
                if (voteElement.length) {
                    voteElement.toggleClass('hasVoted', data.hasVoted);
                    voteElement.html(`<i class="fas fa-heart"></i> ${data.totalVotes}`);
                }
            } else {
                if(data.message=="Unauthorized") {
                    /// show login modal
                    $('#modal_login').css('display', 'flex').hide().fadeIn();
                }
            }
        },
        error: function(error) {
            console.error('Error:', error);
        }
    });
}

window.reOrder = function() {
    $('body').toggleClass('reorderImgs');
    if ($('body').hasClass('reorderImgs')) {
        removeBackGroundDragging();
        enableDragging();
    } else {
        addBackGroundDragging();
        disableDragging();
    }
}

window.enableDragging = function() {
    addPgDragEvents();
    $('.grid-item').attr('draggable', true);

    
}

window.disableDragging = function() {
    removePgDragEvents();
    $('.grid-item').attr('draggable', false);
}

window.updateOrder = function() {
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    const order = [];
    $('.grid-item').each(function (index) {
        const id = $(this).attr('data-pg-id');
        console.log('id:', id);
        order.push({ id: id, order: index + 1 });
    });

    $.ajax({
        url: '/publications/updateOrder/' + window.publicationId,
        method: 'POST',
        contentType: 'application/json',
        headers: {
            'X-CSRF-Token': csrfToken
        },
        data: JSON.stringify({ order: order }),
        success: function (response) {
            console.log('Order updated successfully');
        },
        error: function (error) {
            console.error('Error updating order', error);
        }
    });
}

window.draggedItem = null;

window.addPgDragEvents = function() {


    $('.grid-item').off('dragstart').on('dragstart', function (e) {
        if ($('body').hasClass('reorderImgs')) {
            draggedItem = this;
            setTimeout(() => {
                $(this).css('display', 'none');
            }, 0);
        } else {
            e.preventDefault();
        }
    });

    $('.grid-item').off('dragend').on('dragend', function (e) {
        if ($('body').hasClass('reorderImgs')) {
            setTimeout(() => {
                $(draggedItem).css('display', 'block');
                draggedItem = null;
                updateOrder();
            }, 0);
        }
    });

    $('.grid-item').off('dragover').on('dragover', function (e) {
        if ($('body').hasClass('reorderImgs')) {
            e.preventDefault();
        }
    });

    $('.grid-item').off('dragenter').on('dragenter', function (e) {
        if ($('body').hasClass('reorderImgs')) {
            e.preventDefault();
            $(this).addClass('drag-over');
        }
    });

    $('.grid-item').off('dragleave').on('dragleave', function (e) {
        if ($('body').hasClass('reorderImgs')) {
            $(this).removeClass('drag-over');
        }
    });

    $('.grid-item').off('drop').on('drop', function (e) {
        if ($('body').hasClass('reorderImgs')) {
            $(this).removeClass('drag-over');
            if (draggedItem) {
                $(this).before(draggedItem);
            }
        }
    });
}

window.removePgDragEvents = function() {
    $('.grid-item').off('dragstart dragend dragover dragenter dragleave drop');
}

window.addBackGroundDragging = function() {
    // Global drag-and-drop upload handling
    $(document).on('dragover dragenter', function (e) {
        if (!$('body').hasClass('reorderImgs')) {
            e.preventDefault();
            e.stopPropagation();
            $('body').addClass('dragging'); // Optional visual cue
        }
    });

    $(document).on('dragleave', function (e) {
        if (!$('body').hasClass('reorderImgs')) {
            $('body').removeClass('dragging');
        }
    });

    $(document).on('drop', function (e) {
        if (!$('body').hasClass('reorderImgs')) {
            e.preventDefault();
            e.stopPropagation();
            $('body').removeClass('dragging');
            const filepondInput = document.querySelector('#publication_image');
            if (filepondInput && filepondInput.contains(event.target)) {
                return; 
            }
            if (e.originalEvent.dataTransfer.files.length) {
                const files = e.originalEvent.dataTransfer.files;
                for (const file of files) {
                    pond_pg.addFile(file).then(() => {
                        // Scroll to the bottom after upload
                        setTimeout(() => {
                            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                        }, 500);
                    });
                }
            }
        }
    });
}

window.removeBackGroundDragging = function() {
    $(document).off('dragover dragenter dragleave drop');
}

window.showNewPubMsg = function(){
    $('#modal_newPub').css('display', 'flex').hide().fadeIn();
    confetti({
        spread: 180,
        zIndex: 1001
    });
}